module.exports = __webpack_public_path__ + "static/yulia_2-2fb2c0a7003da1f58cf9b9235dfa0a20.jpg";